import {ErrorHandler, Injectable, Injector, NgZone} from '@angular/core';
import {DialogHelperComponent, DialogType} from '~/app/shared/helpers/dialog-helper';
import {Router} from '@angular/router';
import {BaseService} from '~/app/core/common/services/base.service';
import {ApiService} from '~/app/core/common/services/api.service';
import {SplunkMessage} from '~/app/core/common/models/splunkMessage';
import {ErrorService} from '~/app/core/common/services/error.service';
import {LoadingIndicatorHelper} from "~/app/shared/helpers/loading-indicator-helper";

@Injectable({
    providedIn: 'root'
})
export class GlobalErrorHandlerService implements ErrorHandler {

    public splunkMsg: SplunkMessage = new SplunkMessage();

    constructor(public baseService: BaseService,
                public errorService: ErrorService,
                public apiService: ApiService,
                public dialogHelper: DialogHelperComponent,
                private injector: Injector,
                private _ngZone: NgZone,
                private _loadingIndicatorHelper: LoadingIndicatorHelper,
    ) {

    }

    private get _router() {
        return this.injector.get(Router);
    }

    async handleError(error) {
        console.error(error);
        try {
            let splunkId = Math.random().toString(36).substr(2, 3);
            splunkId += '.';
            splunkId += Math.random().toString(36).substr(2, 3);

            const router = this.injector.get(Router);
            const display = ' SPL.ID: ' + splunkId.toUpperCase();
            const log = 'SPLID.UI: ' + splunkId.toUpperCase();
            const message = error.error ? error.error : this.errorService.sanitizeMessage(error.message);
            console.error(message);

            this.splunkMsg.splid = log + ' page=' + router.url;
            this.splunkMsg.message = error.stack;

            console.log(this.splunkMsg);
            console.error(error.stack);

            this.generateSplunkId(this.splunkMsg).toPromise()
                .then(r => console.log(r))
                .catch(e => console.log(e));

            // TODO clean up logic with error dialogs
            if (this.dialogHelper !== undefined) {
                if (message.length > 3) {
                    console.log('Error Message: ', message);
                    if (message !== undefined && message.includes('An error has occurred making API call for Stores')) {
                        await this.dialogHelper.showNoStoresDialog().then(r => {
                            window.location.reload();
                        });
                    } else {
                        this.dialogHelper.open(
                            {
                                type: DialogType.ERROR,
                                title: 'Error',
                                content: 'An unexpected error has occurred, please contact McLane Helpdesk with the following error code ' + '\n' + display,
                                actions: [
                                    {text: 'Ok', themeColor:"primary"}
                                ],
                                width: 400
                            }).then(results => {
                            if (results === 'Ok') {
                                this._ngZone.run(() => {
                                    this._router.navigateByUrl('/home');
                                    this._loadingIndicatorHelper.hide();
                                });
                            }
                        });

                    }
                } else {
                    this.dialogHelper.open(
                        {
                            type: DialogType.ERROR,
                            title: 'Unexpected Error!',
                            content: 'An unexpected error occurred: ' + '\n' + display,
                            actions: [
                                {text: 'Ok', themeColor:"primary"}
                            ],
                            width: 400
                        }).then(results => {
                        if (results === 'Ok') {
                            this._ngZone.run(() => {
                                this._router.navigateByUrl('/home');
                                this._loadingIndicatorHelper.hide();
                            });
                        }
                    });
                }

            } else {
                alert('An unexpected error occurred. Please contact McLane Helpdesk.' + display);
            }
        } catch (e) {
            console.error(e);
        }

    }

    public generateSplunkId(splunkMsg: SplunkMessage) {
        const json = JSON.stringify(splunkMsg);
        return this.baseService.postHttpJson(
            'generateSplunkId',
            'error-service',
            this.apiService.splunkErrorURL,
            json);
    }
}
